export default __webpack_public_path__ + "static/media/imageHolder.6b01bd59.jpg";